import type { AccountCreatedFromEnum } from '@gql/graphql';
import type { LocationDescriptor } from 'history';

export interface JoinBuyerFromControllerData {
  loginLink?: LocationDescriptor;
  onShowPostSignup?(): void;
  createdFrom?: AccountCreatedFromEnum;
  hasADog?: boolean;
  requireMarketingEmailConsent?: boolean;
}

export interface JoinBuyerFromControllerProps extends JoinBuyerFromControllerData {}
